// extracted by mini-css-extract-plugin
export default {"testo":"Button_testo__lfPR7"};